import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { DateStartEndFromTo } from '../../models/common';
import { getDateForApi } from '../../utils/date';
import { CompanyStateEnum } from '@api/models/enums/CompanyStateEnum';
import { companyService } from '@api/services/services';
import { CompanyDto } from '@api/models/company/CompanyDto';

export interface QcsAdminCompanyListFilter extends ListFilter {
  licenseValid?: DateStartEndFromTo;
  state?: CompanyStateEnum;
}

export type QcsAdminCompanyListState = ListType<CompanyDto, QcsAdminCompanyListFilter>;

const initialState: QcsAdminCompanyListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    sortBy: 'name',
    sortDesc: false,
  },
};

export const qcsAdminCompanyListSlice = listSlice({
  name: 'qcsAdminCompanyList',
  initialState,
});

export const selectQcsAdminCompanyList = (state: RootState) => state.qcsAdminCompanyList;
export const qcsAdminCompanyListActions = qcsAdminCompanyListSlice.actions;

export const getQcsAdminCompanyList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectQcsAdminCompanyList(storeState);

  const handleGetData = (size: number) => {
    return companyService.query(
      {
        q: data.query.q,
        licenseStartFrom: getDateForApi(data.query.licenseValid?.startFrom),
        licenseStartTo: getDateForApi(data.query.licenseValid?.startTo),
        licenseEndFrom: getDateForApi(data.query.licenseValid?.endFrom),
        licenseEndTo: getDateForApi(data.query.licenseValid?.endTo),
        state: data.query.state,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: qcsAdminCompanyListActions,
    getData: handleGetData,
  });
};
